export default "__VITE_ASSET__09f192bb__"